/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Fr1_HeadingInputs */

const en_funnel_sq_fr1_heading = /** @type {(inputs: Funnel_Sq_Fr1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any paper, in a voice that sounds human.`)
};

const es_funnel_sq_fr1_heading = /** @type {(inputs: Funnel_Sq_Fr1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cualquier artículo, con una voz que suena humana.`)
};

/**
* | output |
* | --- |
* | "Any paper, in a voice that sounds human." |
*
* @param {Funnel_Sq_Fr1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_fr1_heading = /** @type {((inputs?: Funnel_Sq_Fr1_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Fr1_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_fr1_heading(inputs)
	return en_funnel_sq_fr1_heading(inputs)
});